import React from 'react';
import axiosClient from '../../api/axiosClient';
import { safeWindowLocation } from '../../utils/safeNavigation';

const SessionTimeoutModal = ({ onStay, onLogout, secondsRemaining }) => {
  return (
    <div
      className="session-timeout-modal"
      style={{
        padding: '20px',
        maxWidth: 360,
        width: '100%',
        backgroundColor: '#fff',
        borderRadius: '6px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
      }}>
      <h3
        style={{
          margin: '0 0 8px 0',
          fontSize: '18px',
          fontWeight: 600,
          color: '#1a1a1a',
        }}>
        Session Timeout Warning
      </h3>
      <p
        style={{
          margin: '0 0 16px 0',
          fontSize: '14px',
          color: '#4a5568',
          lineHeight: 1.5,
        }}>
        You have been inactive for a while. You will be logged out automatically in <strong>{secondsRemaining}</strong>.
      </p>
      <div
        className="actions"
        style={{
          display: 'flex',
          gap: '10px',
          justifyContent: 'flex-end',
        }}>
        <button className="btn btn_outline" onClick={onStay}>
          Stay Logged In
        </button>
        <button
          className="btn btn_primary"
          onClick={async () => {
            try {
              const resp = await axiosClient.get('auth/log-out');
              // Clear local auth footprint to avoid SPA unauthorized route
              document.cookie = 'userDetails=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
              localStorage.setItem('userStatus', 'logged Out');
              // EC-37 follow-up: validate API-provided SLO URL before navigation.
              const sloUrl = resp?.data?.data?.sloLogoutUrl;
              const navigated = sloUrl && safeWindowLocation(sloUrl, 'replace');
              if (!navigated) {
                window.location.replace('/');
              }
            } catch {
              document.cookie = 'userDetails=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
              localStorage.setItem('userStatus', 'logged Out');
              window.location.replace('/');
            }
            onLogout?.();
          }}>
          Logout
        </button>
      </div>
    </div>
  );
};

export default SessionTimeoutModal;
